import { useState } from "react";
import { toast } from "sonner";
import { CalendarX } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, OPC } from "@/lib/api";

export const AnularCitaButton = ({ pid, beforeSubmit, onDone }) => {
  const [open, setOpen] = useState(false);
  const [motivo, setMotivo] = useState("");
  const [detalle, setDetalle] = useState("");
  const [llamar, setLlamar] = useState(false);
  const [fecha, setFecha] = useState("");
  const submit = async () => {
    await beforeSubmit?.();
    await api.post(`/patients/${pid}/anular-cita`, { motivo, detalle, volver_a_llamar: llamar, fecha_rellamada: llamar ? fecha || null : null });
    toast.success("Cita anulada registrada");
    setOpen(false);
    onDone();
  };
  return (
    <>
      <Button variant="outline" data-testid="anular-cita-btn" onClick={() => setOpen(true)} className="border-orange-300 text-orange-700 hover:bg-orange-50">
        <CalendarX className="h-4 w-4 mr-1" />Anula cita
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid="anular-cita-dialog">
          <DialogHeader><DialogTitle className="font-[Outfit]">Cogió cita pero anula</DialogTitle></DialogHeader>
          <select data-testid="anular-motivo" className="field-select" value={motivo} onChange={(e) => setMotivo(e.target.value)}>
            <option value="">Motivo…</option>
            {OPC.motivo_anulacion.map((m) => <option key={m}>{m}</option>)}
          </select>
          <Input data-testid="anular-detalle" placeholder="Detalle (opcional)" value={detalle} onChange={(e) => setDetalle(e.target.value)} />
          <label className="flex items-center gap-2 text-sm text-slate-700">
            <input type="checkbox" data-testid="anular-llamar" checked={llamar} onChange={(e) => setLlamar(e.target.checked)} className="h-4 w-4 accent-orange-600" />
            Quiere que le llamemos más adelante
          </label>
          {llamar && (
            <label className="block text-xs font-semibold uppercase tracking-wider text-slate-500">Volver a llamar el
              <Input type="date" data-testid="anular-fecha-rellamada" value={fecha} onChange={(e) => setFecha(e.target.value)} className="mt-1" />
            </label>
          )}
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button>
            <Button data-testid="anular-confirm" onClick={submit} className="bg-orange-600 hover:bg-orange-700">Registrar anulación</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
